import {Component, Inject, OnInit} from '@angular/core';
import {AttributeDataType, DeviceAttribute} from "../../model/device-attribute.model";
import {DeviceService} from "../device.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DeviceInfo} from "../../model/device-info.model";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MY_FORMATS} from "../../shared/util.service";
import {MomentDateAdapter} from "@angular/material-moment-adapter";


@Component({
    selector: 'app-device-info-dialog',
    templateUrl: './device-info-dialog.component.html',
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class DeviceInfoDialogComponent implements OnInit {

  item: DeviceInfo;
  options: DeviceAttribute[];
  config:any = {};

  constructor(
    private service: DeviceService,
    public dialogRef: MatDialogRef<DeviceInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.initDialog();
  }

  initDialog() {
    this.item = this.data.item;
    this.options = this.data.options;

    if (this.item.attribute) {
      this.onAttributeChange(this.item.attribute)
    }
  }

  onSaveClick() {
    if (!this.item.isValid()) {
      return this.service.notiService.open("Fill every required fields.");
    }
    this.service.saveInfo(this.item).subscribe((resp:any) => {
      if (resp && resp.id) {
        this.service.notiService.open("Mentve.");
        this.dialogRef.close(new DeviceInfo(resp));
      } else {
        this.service.notiService.open(resp.error ? resp.error : "Hiba a mentés közben.");
        console.log(resp);
      }
    })
  }
  onAttributeChange(attr) {
    const config = this.options.find(item => +item.id === +attr).config;
    this.item.value = "";
    if (config) {
      this.data.configs.map(conf => {
        if (conf.id == config) {
          this.config = conf;
        }
      })
    } else {
      this.config = {};
    }
  }

  onDateChange(prop) {
    this.item[prop] = this.item[prop].format('YYYY-MM-DD');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
